import { API_BASE_URL } from "../../config";
import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useFetchUserSeller from "../Utils/useFetchUserSeller";
import Select from "react-select";
import StockCard from "../DDS/cards/StockCard";
import LeaderboardCard from "../DDS/cards/LeaderboardCard";
import SalesCard from "../DDS/cards/SalesCard";

const ROUTE_ONLY = "__ROUTE_ONLY__";

const DashBoard = () => {
    const navigate = useNavigate();

    const handleLogout = useCallback(() => {
        localStorage.removeItem("user");
        navigate("/login");
    }, [navigate]);

    const userIds = useFetchUserSeller(handleLogout);

    // Shared filters
    const today = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    const [startDate, setStartDate] = useState(todayStr);
    const [endDate, setEndDate] = useState(todayStr);
    const [selectedUserId, setSelectedUserId] = useState("");

    const handleStartDateChange = (e) => {
        const v = e.target.value;
        setStartDate(v);
        if (v > endDate) setEndDate(v);
    };
    const handleEndDateChange = (e) => {
        const v = e.target.value;
        setEndDate(v);
        if (startDate > v) setStartDate(v);
    };

    // Resolve filter props for cards
    const sellerIds = selectedUserId === ROUTE_ONLY
        ? (userIds || []).map(u => u.uid).filter(Boolean)
        : null;
    const sellerId = (selectedUserId && selectedUserId !== ROUTE_ONLY) ? selectedUserId : null;

    return (
        <div className="btc-container">
            <div><h1 className="btc-heading">หน้าต่างแสดงผล</h1></div>

            {/* Shared filters */}
            <div className="btc-user-selection" style={{ display: "flex", marginBottom: "10px", alignItems: "center", gap: "10px" }}>
                <label htmlFor="user-select">สายที่แสดงข้อมูล:</label>
                <div style={{ width: "20%", paddingRight: "10px" }}>
                    <Select
                        id="user-select"
                        options={[
                            { value: "", label: "แสดงทั้งหมด" },
                            { value: ROUTE_ONLY, label: "แสดงเฉพาะสายรถ" },
                            ...(userIds || []).map(u => ({ value: u.uid, label: u.nameuser, username: u.username })),
                        ]}
                        value={
                            selectedUserId === ROUTE_ONLY
                                ? { value: ROUTE_ONLY, label: "แสดงเฉพาะสายรถ" }
                                : selectedUserId
                                    ? { value: selectedUserId, label: (userIds || []).find(u => u.uid === selectedUserId)?.nameuser }
                                    : { value: "", label: "แสดงทั้งหมดสาย" }
                        }
                        onChange={(opt) => setSelectedUserId(opt?.value || "")}
                        formatOptionLabel={(opt) => (
                            <div>
                                <span style={{ fontWeight: "bold" }}>{opt.label}</span>
                                {opt.username && <span style={{ fontSize: "small", color: "gray" }}> ({opt.username})</span>}
                            </div>
                        )}
                        className="btc-selectBox-container"
                        classNamePrefix="btc-selectBox"
                        isClearable
                    />
                </div>
                <label>ช่วงวันที่:</label>
                <input style={{ width: "10%", paddingRight: "10px" }} type="date" value={startDate} onChange={handleStartDateChange} />
                <span>ถึง</span>
                <input style={{ width: "10%", paddingRight: "10px" }} type="date" value={endDate} onChange={handleEndDateChange} />
            </div>

            {/* Top row: Stock + Leaderboard side by side */}
            <div className="btc-tables-container">
                <StockCard
                    startDate={startDate} endDate={endDate}
                    sellerId={sellerId} sellerIds={sellerIds}
                    onLogout={handleLogout}
                />
                <LeaderboardCard
                    startDate={startDate} endDate={endDate}
                    sellerId={sellerId} sellerIds={sellerIds}
                    onLogout={handleLogout}
                />
            </div>

            {/* Full-width sales table */}
            <SalesCard
                startDate={startDate} endDate={endDate}
                sellerId={sellerId} sellerIds={sellerIds}
                onLogout={handleLogout}
            />
        </div>
    );
};

export default DashBoard;
